import { select, call } from 'redux-saga/effects'
import HTTPClient from './HTTPClient'
import prefixUrl from './interceptors/prefixUrl'
import config from '../config'
import { selectors } from '../sagas/session'
import returnJsonIfSuccessful from './interceptors/returnJsonIfSuccessful'
import handleUserNotLoggedIn from './interceptors/handleUserNotLoggedIn'
// import { push } from 'react-router-redux'

function setDefaultHeaders (request) {
  const defaultHeaders = {
    Accept: 'application/json'
  }

  if (!(request.body instanceof FormData)) {
    defaultHeaders['Content-Type'] = 'application/json'
  }

  return Object.assign(request, {
    headers: Object.assign(defaultHeaders, request.headers)
  })
}

export const client = HTTPClient({
  requestInterceptors: [
    prefixUrl(config.API_BASE_URL),
    setDefaultHeaders
  ],

  responseInterceptors: [
    handleUserNotLoggedIn,
    returnJsonIfSuccessful
  ]
})

function buildOptions(options, token) {
  const headers = {
    'Authorization': `Bearer ${token}`
  }
  const newOptions = Object.assign({}, options, { headers })
  return newOptions
}

function* fetchRequest(params) {
  const { url, ...options } = params
  const token = yield select(selectors.token)
  let data = yield call(client.fetch, url, buildOptions(options, token))
  if(data && data.status && data.status >= 400) {
    if (data.status === 401) {
      console.error(data.status, data.errors)
    }
  }
  return data
}

export function* reduxFetch (params) {
  const data = yield call(fetchRequest, params)
  return data
}



// WEBPACK FOOTER //
// ./src/http/reduxFetch.js